<script>
import { orderTypes, userTypes } from "@/store/types/types.js";
import Search from "@/components/Search";
import BagCardModal from "@/components/BagCardModal";
import CustomerCardModal from "@/components/CustomerCardModal";
import MealCalcModal from "@/components/MealCalcModal";
import EditOrderModal from "@/components/EditOrderModal";
import DayPicker from "@/components/DayPicker";
import SmallModal from "@/components/SmallModal";
import CustomerModal from "@/components/CustomerModal";
import * as moment from "moment";
export default {
  name: "today-delivery",
  components: {
    Search,
    DayPicker,
    MealCalcModal,
    BagCardModal,
    CustomerCardModal,
    EditOrderModal,
    SmallModal,
    CustomerModal
  },
  data() {
    return {
      date: "",
      filterList: [],
      length: 0,
      editOrderId: 0,
      editOrderList: [],
      prepayList: [],
      deleteOrderId: 0,
      filterDate: "",
      filterDateList: [],
      title: "編輯顧客",
      index: -1,
      user: {}
    };
  },
  computed: {
    userList() {
      return this.$store.getters[orderTypes.getters.getTodayOrderList];
    }
  },
  methods: {
    successOrderMsg() {
      alert("修改成功！");
    },
    resetIndex(data) {
      this.$store
        .dispatch(userTypes.actions.QUERY_SINGLE_USER, data.user_id)
        .then(user => {
          this.index = data.user_id;
          this.user = user;
        });
      // if (data < 0) {
      //   this.initList();
      // }
    },
    clickCheckByModal() {
      let id = this.deleteOrderId;
      this.$store.dispatch(orderTypes.actions.DELETE_ORDER, id).then(() => {
        this.filterList.forEach((user, uIndex) => {
          user.orderList.find((order, oIndex) => {
            if (order.id == this.deleteOrderId) {
              this.filterList[uIndex].orderList.splice(oIndex, 1);
            }
          });
        });
      });
    },
    deleteOrder(orderId, order) {
      if (order.is_delivered) {
        alert("已送餐，無法刪除訂單！");
        return;
      }
      this.$jquery("#smallModal").modal("show");
      this.deleteOrderId = orderId;
    },
    getDay(data) {
      let list = JSON.parse(JSON.stringify(this.userList));
      this.filterDate = data;
      let time = moment(data).format("YYYY-MM-DD");
      this.filterDateList = list.filter(user => {
        user.orderList = user.orderList.filter(order => {
          return order.delivered_at == time;
        });
        return user.orderList.length !== 0;
      });
      this.length = this.filterDateList.length;
      this.filterList = this.filterDateList;
      //要送 page:1 進 search component
    },
    updateOrderList() {
      this.successOrderMsg();
      this.initList();
    },
    editOrder(userId, orderId) {
      this.editOrderId = orderId;
      let chooseUser;
      this.userList.filter(user => {
        if (user.user_id === userId) {
          this.editOrderList = user.orderList;
          this.prepayList = user.prepayList;
          chooseUser = user;
        }
      });
      chooseUser.orderList.filter(order => {
        if (order.id === orderId) {
          if (order.is_delivered) {
            return alert("餐點已送出，無法修改！");
          }
          this.$jquery("#editOrderModal").modal("show");
        }
      });
    },
    checkPrepayDay(user) {
      return user.prepay <= 3;
    },
    search(data) {
      let q = data.q;
      this.filterList = this.filterList.filter(user => {
        let address = user.orderList.reduce((acc, cur) => {
          return (acc += cur.address);
        }, "");
        return (
          user.name.includes(q) || address.includes(q) || user.phone.includes(q)
        );
      });
      if (!data.q) this.filterList = this.userList;
      this.filterList = this.filterList.slice(0, 30);
      this.length = this.filterList.length;
    },
    emptyAddress(address, addressList) {
      let result = addressList.find(userAddress => {
        return userAddress == address;
      });
      return !result;
    },
    getPage(data) {
      let page = data.page;
      let q = data.q;
      //分頁錯誤：這邊要改成 userList 可是點選日期要可以搜尋原本日期裡面顧客的資料。
      let currentlist = [];
      !this.filterDate
        ? (currentlist = this.userList)
        : (currentlist = this.filterDateList);
      this.filterList = currentlist.filter(user => {
        let address = user.orderList.reduce((acc, cur) => {
          return (acc += cur.address);
        }, "");
        return (
          user.name.includes(q) ||
          address.includes(q) ||
          user.phone.main.includes(q)
        );
      });
      this.filterList = this.filterList.slice((page - 1) * 30, page * 30);
      let container = this.$el.querySelector(".scroll-view");
      container.scrollTop = -container.scrollHeight;
      // this.length = this.filterList.length;
    },
    transToChinese(weekday) {
      let weekdayMapping = ["一", "二", "三", "四", "五"];
      return weekdayMapping[weekday];
    },
    editCashBag(event, id) {
      let data = {
        is_cashbag_out: event.target.checked,
        id: id
      };
      this.$store
        .dispatch(userTypes.actions.EDIT_USER_CASH_BAG, data)
        .then(() =>
          this.$store.dispatch(
            orderTypes.actions.GET_TODAY_ORDER_LIST,
            this.date
          )
        );
    },
    editOrderAddress(event, id) {
      let data = {
        address: event.target.value,
        id: id
      };
      this.$store.dispatch(orderTypes.actions.EDIT_ORDER, data).then(() => {
        this.$store.dispatch(
          orderTypes.actions.GET_TODAY_ORDER_LIST,
          this.date
        );
        alert("已成功修改地址！");
      });
    },
    initList() {
      this.date = moment().format("YYYY-MM-DD");
      this.$store
        .dispatch(orderTypes.actions.GET_TODAY_ORDER_LIST, this.date)
        .then(() => {
          let emptyList = [];
          this.filterDate = "";
          this.length = this.userList.length;
          this.filterList = this.userList;
          this.userList.forEach(user => {
            let addressList = user.address.reduce((acc, cur) => {
              return (acc += cur);
            }, "");
            user.address.forEach(address => {
              user.orderList.forEach(order => {
                if (
                  order.address !== address &&
                  !addressList.includes(order.address)
                ) {
                  emptyList.push(order.user_id);
                }
              });
            });
          });
          emptyList = Array.from(new Set(emptyList));
          if (emptyList.length) {
            alert("顧客資料有更新，請修改配送地址！");
            this.filterList = this.filterList.sort(a => {
              return emptyList.find(id => a.user_id === id) ? -1 : 1;
            });
          }
        });
    }
  },
  watch: {
    userList: {
      handler(val) {
        if (this.filterList.length == 0 && !this.filterDate) {
          this.filterList = val.filter(user => user.orderList.length !== 0);
        }
        this.length = this.userList.length;
      },
      deep: true
    }
  },
  mounted() {
    this.initList();
  }
};
</script>


<template src="./template.html"></template>
<style lang="scss" src="./style.scss"/>